<template>
  <BaseEdit :job="edittedJob || job" :onSave="onSave"/>
</template>

<script>
import BaseEdit from './BaseEdit';

export default {
  props: {
    job: Object,
  },
  data() {
    return {
      edittedJob: null,
    };
  },
  components: {
    BaseEdit,
  },
  methods: {
    async onSave(data) {
      try {
        this.edittedJob = (await this.$http.patch(`jobs/${this.job.id}/`, data)).data;
        this.$toast.open({
          message: 'Job updated',
          type: 'is-success',
        });
      } catch (e) {
        this.$toast.open({
          message: 'Failed to update Job',
          type: 'is-danger',
        });
      }
    },
  },

};
</script>
